import { fontList } from '../../core/font-list';
import { colorListPairs } from '../../core/color-list';

export let params = {
  'parameters': {
    'size': {
      'default': {
        'key': '600 x 600',
        'value': [600, 600],
        'label': '600 x 600'
      },
      'label': 'Afmeting',
      'type': 'array',
      'values': [
        {
          'key': '1500 x 1500',
          'value': [1500, 1500],
          'label': '1500 x 1500'
        },
        {
          'key': '1200 x 1200',
          'value': [1200, 1200],
          'label': '1200 x 1200'
        },
        {
          'key': '900 x 900',
          'value': [900, 900],
          'label': '900 x 900'
        },
        {
          'key': '600 x 600',
          'value': [600, 600],
          'label': '600 x 600'
        },
        {
          'key': '400 x 400',
          'value': [400, 400],
          'label': '400 x 400'
        },
        {
          'key': '300 x 300',
          'value': [300, 300],
          'label': '300 x 300'
        },
      ],
      'control': 'standard-select',
      'description': 'Afmeting van de visualisatie',
    },
    'width': {
      'default': 600,
      'label': 'Breedte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'height': {
      'default': 600,
      'label': 'Hoogte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'fontFamily': {
      'default': 'Arial',
      'label': 'Font',
      'type': 'string',
      'control': 'standard-control',
    },
    'fontColor': {
      'default': '#707070',
      'label': 'Font kleur',
      'type': 'string',
      'control': 'standard-control',
    },
    'marginLeft': {
      'default': 20,
      'label': 'Linkermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginRight': {
      'default': 20,
      'label': 'Rechtermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginTop': {
      'default': 30,
      'label': 'Bovenmarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginBottom': {
      'default': 30,
      'label': 'Ondermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'stackBars': {
      'default': false,
      'label': 'Stapel de staven',
      'type': 'boolean',
      'control': 'standard-checkbox',
    },
    'categoryMarginRatio': {
      'default': 0.75,
      'label': 'Verhouding staven en witruimte, categorieën',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'subCategoryMarginRatio': {
      'default': 0.9,
      'label': 'Verhouding staven en witruimte, sub-categorieën',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'unitFontFamily': {
      'default': 'Arial',
      'label': 'Unit font',
      'type': 'string',
      'control': 'standard-control',
    },
    'unitFontSize': {
      'default': 16,
      'label': 'Unit fontgrootte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'unitText': {
      'default': 'Index 2015 = 100',
      'label': 'Unit tekst',
      'type': 'string',
      'control': 'standard-control',
    },
    'unitMarginTop': {
      'default': 20,
      'label': 'Unit bovenmarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'unitMarginBottom': {
      'default': 40,
      'label': 'Unit ondermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleText': {
      'default': 'Producer Price Index (PPI)',
      'label': 'Titel tekst',
      'type': 'string',
      'control': 'standard-textarea',
    },
    'titleFontFamily': {
      'default': 'Arial',
      'label': 'Titel font',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleFontSize': {
      'default': 20,
      'label': 'Font grootte titel',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleLineHeight': {
      'default': 1.1,
      'label': 'Regelhoogte titel',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleMarginBottom': {
      'default': 10,
      'label': 'Marge onder de titel',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleFontColor': {
      'default': '#2C2C2C',
      'label': 'Font kleur titel',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleFontWeight': {
      'default': 700,
      'label': 'Font dikte titel',
      'type': 'string',
      'control': 'standard-number',
    },
    'subTitleText': {
      'default': '1/2015–4/2018',
      'label': 'Sub-titel tekst',
      'type': 'string',
      'control': 'standard-textarea',
    },
    'subTitleFontFamily': {
      'default': 'Arial',
      'label': 'Sub-titel font',
      'type': 'string',
      'control': 'standard-control',
    },
    'subTitleFontSize': {
      'default': 16,
      'label': 'Font grootte sub-titel',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'subTitleLineHeight': {
      'default': 1.1,
      'label': 'Regelhoogte sub-titel',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'subTitleMarginBottom': {
      'default': 14,
      'label': 'Marge onder de sub-titel',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'subTitleFontColor': {
      'default': '#707070',
      'label': 'Font kleur sub-titel',
      'type': 'string',
      'control': 'standard-control',
    },
    'subTitleFontWeight': {
      'default': 500,
      'label': 'Font dikte sub-titel',
      'type': 'string',
      'control': 'standard-number',
    },
    'sourceFontFamily': {
      'default': 'Arial',
      'label': 'Bron font',
      'type': 'string',
      'control': 'standard-control',
    },
    'sourceFontSize': {
      'default': 16,
      'label': 'Bron fontgrootte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'sourceText': {
      'default': null,
      'label': 'Bron tekst',
      'type': 'string',
      'control': 'standard-control',
    },
    'sourceMargin': {
      'default': 14,
      'label': 'Bron marge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelSpaceX': {
      'default': 56,
      'label': 'Label ruimte X',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelSpaceBackgroundColor': {
      'default': '#0073B0',
      'label': 'Label ruimte achtergrondkleur',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelSpaceLogoColor': {
      'default': '#929292',
      'label': 'Logo kleur X-as',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelSpaceLogoWidth': {
      'default': 20,
      'label': 'Logo breedte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelSpaceLogoOffsetX': {
      'default': 10,
      'label': 'Logo afstand tot kader X',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelSpaceLogoOffsetY': {
      'default': 10,
      'label': 'Logo afstand tot kader Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelSpaceLineStrokeColor': {
      'default': '#BDBCBC',
      'label': 'Label ruimte lijnkleur',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelSpaceLineStrokeWidth': {
      'default': 3,
      'label': 'Label ruimte lijndikte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'xAxisLineStrokeColor': {
      'default': '#FFFFFF',
      'label': 'Kleur X-as markers',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'xAxisMarkerOffset': {
      'default': 4,
      'label': 'Offset marker X-as',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'xAxisMarkerLength': {
      'default': 6,
      'label': 'Marker lengte X-as',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'xAxisMarkerWidth': {
      'default': 1,
      'label': 'Marker dikte X-as',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'xAxisYearMarkerLength': {
      'default': 18,
      'label': 'Jaarmarker lengte X-as',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'xAxisYearMarkerWidth': {
      'default': 1,
      'label': 'Jaarmarker dikte X-as',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'xAxisLabelOffset': {
      'default': 16,
      'label': 'Afstand labels X-as',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'xAxisYearOffset': {
      'default': 36,
      'label': 'Afstand labels X-as',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'xAxisLabelFontFamily': {
      'default': 'Arial',
      'label': 'Labels X-as font',
      'type': 'string',
      'control': 'standard-control',
    },
    'xAxisLabelFontSize': {
      'default': 8,
      'label': 'Labels X-as fontgrootte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'xAxisLabelFontColor': {
      'default': '#FFFFFF',
      'label': 'Kleur X-as labels',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'xAxisYearFontSize': {
      'default': 16,
      'label': 'Jaren X-as fontgrootte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'xAxisShowYears': {
      'default': {
        'key': 'all',
        'value': 'all',
        'label': 'Alle'
      },
      'label': 'Toon jaarlabels',
      'type': 'string',
      'values': [
        {
          'key': 'all',
          'value': 'all',
          'label': 'Alle'
        },
        {
          'key': 'even',
          'value': 'even',
          'label': 'Even'
        },
        {
          'key': 'odd',
          'value': 'odd',
          'label': 'Oneven'
        },
        {
          'key': 'five',
          'value': 'five',
          'label': '5-tallen'
        },
        {
          'key': 'skip 1',
          'value': 'skip 1',
          'label': 'Sla 1 over'
        },
        {
          'key': 'skip 2',
          'value': 'skip 2',
          'label': 'Sla 2 over'
        },
        {
          'key': 'firstAndLast',
          'value': 'firstAndLast',
          'label': 'Eerste en laatste'
        },
      ],
      'control': 'standard-select',
      'description': 'Toon bepaalde jaarlabels en andere niet',
    },
    'xAxisShowPeriod': {
      'default': false,
      'label': 'Toon sub-periode label',
      'type': 'boolean',
      'control': 'standard-checkbox',
    },
    'xAxisForceFirstAndLastYear': {
      'default': false,
      'label': 'Toon eerste en laatste jaar',
      'type': 'boolean',
      'control': 'standard-checkbox',
    },
    'minY': {
      'default': 95,
      'label': 'Min Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'maxY': {
      'default': 110,
      'label': 'Max Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'stepY': {
      'default': 5,
      'label': 'Stapgrootte Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'yAxisMarkerStrokeWidth': {
      'default': 1,
      'label': 'Dikte Y-as markers',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'yAxisMarkerStrokeColor': {
      'default': '#808285',
      'label': 'Kleur Y-as markers',
      'type': 'string',
      'control': 'standard-control',
    },
    'yAxisLabelWidth': {
      'default': 100,
      'label': 'Breedte Y-as labelruimte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'yAxisLabelOffset': {
      'default': 10,
      'label': 'Afstand Y-as labels tot as',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'yAxisLabelFontFamily': {
      'default': 'Arial',
      'label': 'Labels Y-as font',
      'type': 'string',
      'control': 'standard-control',
    },
    'yAxisLabelFontSize': {
      'default': 16,
      'label': 'Labels Y-as fontgrootte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'yAxisLabelDecimals': {
      'default': 0,
      'label': 'Decimalen Y-as labels',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'chartMargin': {
      'default': 30,
      'label': 'Marge links en rechts van de grafiek',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'reverseColors': {
      'default': false,
      'label': 'Draai kleurvolgorde om',
      'type': 'boolean',
      'control': 'standard-checkbox',
    },
    'lineStrokeWidth': {
      'default': 3,
      'label': 'Lijnbreedte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'lineJoin': {
      'default': {
        'key': 'miter',
        'value': 'miter',
        'label': 'Punt'
      },
      'label': 'Lijn aansluiting',
      'type': 'string',
      'values': [
        {
          'key': 'miter',
          'value': 'miter',
          'label': 'Punt'
        },
        {
          'key': 'round',
          'value': 'round',
          'label': 'Afgerond'
        }
      ],
      'control': 'standard-select',
      'description': 'Wijze waarop de lijnaasluitingen worden getekend',
    },
    'legendMarginTop': {
      'default': 20,
      'label': 'Legenda bovenmarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendHorizontalSpacing': {
      'default': 20,
      'label': 'Legenda horizontale tussenmarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendVerticalSpacing': {
      'default': 20,
      'label': 'Legenda verticale tussenmarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendRowHeight': {
      'default': 16,
      'label': 'Legenda regel hoogte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendFontSize': {
      'default': 16,
      'label': 'Legenda fontgrootte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendFontFamily': {
      'default': 'Arial',
      'label': 'Legenda font',
      'type': 'string',
      'control': 'standard-control',
    },
    'legendColumns': {
      'default': 3,
      'label': 'Legenda aantal kolommen',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendMarkerWidth': {
      'default': 15,
      'label': 'Legenda breedte marker',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendMarkerMargin': {
      'default': 10,
      'label': 'Legenda marge marker en tekst',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendWrapping': {
      'default': {
        'key': 'down',
        'value': 'down',
        'label': 'Boven naar beneden'
      },
      'label': 'Legenda omloop',
      'type': 'string',
      'values': [
        {
          'key': 'down',
          'value': 'down',
          'label': 'Boven naar beneden'
        },
        {
          'key': 'right',
          'value': 'right',
          'label': 'Links naar rechts'
        }
      ],
      'control': 'standard-select',
      'description': 'Volgorde waarin de legenda items worden getekend',
    },
    'formatLocale': {
      'default': {
        'key': 'nl-nl',
        'value': 'nl-nl',
        'label': 'Nederlands'
      },
      'label': 'Taal',
      'type': 'string',
      'values': [
        {
          'key': 'nl-nl',
          'value': 'nl-nl',
          'label': 'Nederlands'
        },
        {
          'key': 'en-gb',
          'value': 'en-gb',
          'label': 'Engels'
        }
      ],
      'control': 'standard-select',
      'description': 'Taal voor het formatteren van de Y-as labels',
    },
  },
  'data': {
    'values': [[null, null, 'PPI Total', 'Domestic goods', 'Export goods'], ['2015', 'j' ,99.3,99.7,99.0], ['2015', 'f' ,100.4,100.5,100.4], ['2015', 'm' ,101.1,100.9,101.1], ['2015', 'a' ,101.5,101.0,101.8], ['2015', 'm' ,101.5,100.9,101.9], ['2015', 'j' ,101.2,101.0,101.4], ['2015', 'j' ,101.1,100.6,101.4], ['2015', 'a' ,99.8,99.8,99.9], ['2015', 's' ,99.1,99.3,98.9], ['2015', 'o' ,98.8,99.0,98.6], ['2015', 'n' ,98.6,99.0,98.3], ['2015', 'd' ,97.7,98.3,97.3], ['2016', 'j' ,97.4,97.6,97.1], ['2016', 'f' ,96.2,97.1,95.4], ['2016', 'm' ,96.7,97.4,96.1], ['2016', 'a' ,96.8,97.3,96.3], ['2016', 'm' ,97.2,97.5,96.9], ['2016', 'j' ,97.1,97.6,96.8], ['2016', 'j' ,96.7,97.5,96.1], ['2016', 'a' ,97.1,97.4,96.9], ['2016', 's' ,97.5,97.8,97.3], ['2016', 'o' ,98.2,98.3,98.1], ['2016', 'n' ,98.2,98.4,98.2], ['2016', 'd' ,99.4,99.2,99.7], ['2017', 'j' ,100.4,99.9,100.8], ['2017', 'f' ,100.8,100.0,101.4], ['2017', 'm' ,100.7,100.2,101.2], ['2017', 'a' ,101.0,100.2,101.9], ['2017', 'm' ,100.6,100.2,101.2], ['2017', 'j' ,100.0,99.8,100.4], ['2017', 'j' ,100.3,99.9,100.7], ['2017', 'a' ,100.2,100.0,100.6], ['2017', 's' ,100.7,100.2,101.3], ['2017', 'o' ,101.3,100.5,102.2], ['2017', 'n' ,102.1,101.2,103.2], ['2017', 'd' ,102.4,101.7,103.1], ['2018', 'j' ,102.9,102.1,103.9], ['2018', 'f' ,102.9,102.0,103.9], ['2018', 'm' ,103.7,102.2,105.2], ['2018', 'a' ,104.4,102.6,106.2]],
    'columnLimitMin': 1,
    'columnLimitMax': 8,
    'columnLabelNumber': 1,
    'rowLimitMin': 1,
    'rowLimitMax': null,
    'rowLabelNumber': 2,
  },
  'parameterGroups': [
    {
      'title': 'Primair',
      'collapsed': false,
      'keys': ['size', 'minY', 'maxY', 'stepY', 'yAxisLabelDecimals', 'reverseColors', 'titleText', 'subTitleText', 'unitText', 'legendColumns', 'formatLocale'],
    },
    {
      'title': 'Secundair',
      'collapsed': true,
      'keys': ['titleFontSize', 'chartMargin', 'lineJoin', 'sourceText', 'xAxisShowYears', 'xAxisShowPeriod', 'legendWrapping'],
    }
  ],
  'metadata': {
    'category': 'still',
    'outputTypes': ['png', 'svg'],
    'showEmbedControl': true,
  },
};



// WEBPACK FOOTER //
// ./src/app/animations/demo-tilastokeskus-line/social.params.ts